import React, { useEffect, useMemo, useState } from "react";
import NormalMode from "../../components/Main/TerminalModes/Normal/NormalMode/NormalMode";
import { TerminalMode } from "../TerminalPage/TerminalPage";
import { OrderUnitsType } from "../../types/Terminal/TerminalTypes";
import { TerminalAppearanceResponse } from "../../types/Admin/TerminalAppearanceTypes";

const makeCssImportant = (css: string) => {
  if (!css) return "";
  return css.replace(/:([^;{}]+);/g, (match, value) => {
    if (value.includes("!important")) {
      return match;
    }
    return `:${value.trim()} !important;`;
  });
};

type TerminalPreviewMessage =
  | {
      type: "TERMINAL_PREVIEW_APPEARANCE";
      payload: {
        appearance: TerminalAppearanceResponse;
        isChildrenMode?: boolean;
      };
    }
  | {
      type: "TERMINAL_PREVIEW_ORDER_UNITS";
      payload: { orderUnitsData: OrderUnitsType };
    }
  | { type: string; payload?: any };

const mockOrderUnitsData: OrderUnitsType = {
  id: 0,
  name: "preview",
  terminalIp: "0.0.0.0",
  categoryView: {
    topics: [
      {
        id: 1,
        isActiveNow: true,
        nameRu: "Услуга 1",
        nameBe: "Паслуга 1",
        nameEn: "Service 1",
      },
      {
        id: 2,
        isActiveNow: true,
        nameRu: "Услуга 2",
        nameBe: "Паслуга 2",
        nameEn: "Service 2",
      },
      {
        id: 3,
        isActiveNow: true,
        nameRu: "Услуга 3",
        nameBe: "Паслуга 3",
        nameEn: "Service 3",
      },
      {
        id: 4,
        isActiveNow: true,
        nameRu: "Услуга 4",
        nameBe: "Паслуга 4",
        nameEn: "Service 4",
      },
      {
        id: 5,
        isActiveNow: true,
        nameRu: "Услуга 5",
        nameBe: "Паслуга 5",
        nameEn: "Service 5",
      },
      {
        id: 6,
        isActiveNow: true,
        nameRu: "Услуга 6",
        nameBe: "Паслуга 6",
        nameEn: "Service 6",
      },
    ],
    categories: [],
  },
  misConfig: {
    benefitsEffective: false,
    otoEffective: true,
    otoAllowsDigitalCode: true,
    otoAllowsBarcode: true,
    privilegeTypes: [
      {
        id: 0,
        kind: "EMERGENCY",
        nameRu: "Экстренная очередь (CITO)",
        nameBe: "Экстрэнная чарга (CITO)",
        nameEn: "Emergency queue (CITO)",
        misCode: null,
        ticketPrefix: null,
        priority: 20,
        isActive: true,
      },
    ],
  },
};

const TerminalPreviewPage = () => {
  const [mode, setMode] = useState<TerminalMode>(TerminalMode.Normal);
  const [previewAppearance, setPreviewAppearance] =
    useState<TerminalAppearanceResponse | null>(null);
  const [previewOrderUnitsData, setPreviewOrderUnitsData] =
    useState<OrderUnitsType>(mockOrderUnitsData);
  const [isChildrenMode, setIsChildrenMode] = useState(false);

  useEffect(() => {
    const handler = (event: MessageEvent<TerminalPreviewMessage>) => {
      const data = event.data;
      if (!data || typeof data !== "object") return;
      if (data.type === "TERMINAL_PREVIEW_APPEARANCE") {
        const incoming = data.payload?.appearance;
        if (!incoming?.settings) return;
        setPreviewAppearance(incoming);
        if (typeof data.payload?.isChildrenMode === "boolean") {
          setIsChildrenMode(data.payload.isChildrenMode);
        }
        return;
      }
      if (data.type === "TERMINAL_PREVIEW_ORDER_UNITS") {
        const incoming = data.payload?.orderUnitsData;
        if (!incoming?.categoryView) return;
        setPreviewOrderUnitsData(incoming);
      }
    };
    window.addEventListener("message", handler as any);
    return () => window.removeEventListener("message", handler as any);
  }, []);

  const effectiveCustomCss = useMemo(() => {
    const css = previewAppearance?.settings?.customCss;
    return css ? makeCssImportant(css) : "";
  }, [previewAppearance?.settings?.customCss]);

  return (
    <>
      <NormalMode
        setMode={setMode}
        orderUnitsData={previewOrderUnitsData}
        tickerText=""
        appearance={previewAppearance ?? undefined}
        previewChildrenModeOverride={isChildrenMode}
        isPreviewMode
      />

      {effectiveCustomCss && (
        <style dangerouslySetInnerHTML={{ __html: effectiveCustomCss }} />
      )}
    </>
  );
};

export default TerminalPreviewPage;

